import { SelectInput } from 'components/Forms';
import { TimezoneOption, timeZoneOptions } from 'domains/timezone';
import { isUndefined, noop } from 'lodash';
import { ChangeEvent } from 'react';

type TimezoneSelectorProps = {
  displayTimezone: TimezoneOption | undefined;
  setDisplayTimezone: (timezone: TimezoneOption) => void;
};

export const TimezoneSelector = ({ displayTimezone, setDisplayTimezone }: TimezoneSelectorProps) => (
  <SelectInput
    data-testid="schedule-timezone-select"
    className="font-inter font-medium text-[13px] leading-[20px]"
    labelClassName="font-inter font-medium text-[13px] leading-[20px]"
    label="Select your timezone"
    options={timeZoneOptions}
    name="displayTimezone"
    value={displayTimezone?.value}
    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
      const newTimezone = timeZoneOptions.find(({ value }) => value === e.target.value) as TimezoneOption;
      setDisplayTimezone(newTimezone);
    }}
    clearValue={noop}
    setError={noop}
    setValue={noop}
    disabled={false}
    allowEmpty
    hint={isUndefined(displayTimezone) ? 'Please select your timezone' : undefined}
  />
);
